<div [ngClass]="isCustomUiChange ? 'loader-container' : 'spinner-center'" *ngIf="searching">
  <mat-spinner [diameter]="80" color="primary"></mat-spinner>
</div>
<div [ngClass]="isCustomUiChange ? 'programSponsors-container' : ''" [hidden]="searching">
  <mat-card [ngClass]="isCustomUiChange ? 'programSponsors-card' : 'user-card'">
    <mat-card-header *ngIf="!isCustomUiChange">
      <mat-card-title class="title-text">
        <span matBadge="{{ programSponsors.length }}" matBadgeOverlap="false">Program Sponsors</span>
      </mat-card-title>
      <div class="add-btn-wrapper">
        <button mat-button (click)="addNewPSponsor()" matTooltip="Add" class="add-btn">
          <mat-icon matTooltip="Add ProgramSponsor" aria-hidden="false" color="primary" class="add-icon">
            add
          </mat-icon>
        </button>
      </div>
    </mat-card-header>

    <!-- new CSS chages apply for FEMD and DOM1 -->
    <mat-card-header *ngIf="isCustomUiChange" class="programSponsors-header">
      <mat-card-title class="programSponsors-title">
        <span matBadge="{{ programSponsors.length }}" matBadgeOverlap="false">Program Sponsors</span>
      </mat-card-title>

      <!-- Search Bar -->
      <mat-form-field appearance="outline" class="programSponsors-search-field">
        <mat-label>Search</mat-label>
        <input matInput [(ngModel)]="searchValue" (ngModelChange)="applyFilter()" placeholder="Search programSponsors..."
          autocomplete="off" />
        <button mat-icon-button matSuffix *ngIf="searchValue" (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <button mat-icon-button class="add-office-btn" (click)="addNewPSponsor()">
        <mat-icon matTooltip="Add Office" color="primary">add</mat-icon>
      </button>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content [ngClass]="isCustomUiChange ? 'programSponsors-table-section' : ''">
      <br *ngIf="!isCustomUiChange">
      <table mat-table [dataSource]="dataSource" matSort [ngClass]="isCustomUiChange ? 'programSponsors-table' : ''"
        class="mat-elevation-z8">
        <ng-container matColumnDef="ProgramSponsorId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="isCustomUiChange ? '' : 'col-id'">Program Sponsor ID</th>
          <td mat-cell *matCellDef="let sponsor" matTooltip="{{ sponsor.ProgramSponsorId }}">
            {{ sponsor.ProgramSponsorId }} </td>
        </ng-container>

        <ng-container matColumnDef="ProgramSponsorDescription">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="isCustomUiChange ? '' : 'col-name'">Name</th>
          <td mat-cell *matCellDef="let sponsor" matTooltip="{{ sponsor.ProgramSponsorDescription }}">
            {{sponsor.ProgramSponsorDescription}} </td>
        </ng-container>

        <ng-container matColumnDef="CompassUri">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="isCustomUiChange ? '' : 'col-uri'">Compass URI</th>
          <td mat-cell *matCellDef="let sponsor" matTooltip="{{ sponsor.CompassUri }}"> {{sponsor.CompassUri}} </td>
        </ng-container>

        <ng-container matColumnDef="CompassAuthorization">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="isCustomUiChange ? '' : 'col-auth'">Compass Authorization</th>
          <td mat-cell *matCellDef="let sponsor">
            <mat-icon matTooltip="Security" *ngIf="sponsor.CompassAuthorization">security</mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="ProgramSponsorActive">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="isCustomUiChange ? '' : 'col-active'">Active</th>
          <td mat-cell *matCellDef="let sponsor">
            <mat-icon matTooltip="Check" *ngIf="sponsor.ProgramSponsorActive" color="primary">check_box</mat-icon>
            <mat-icon matTooltip="Cancel" *ngIf="!sponsor.ProgramSponsorActive" style="color: red !important">cancel</mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="CreatedDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="isCustomUiChange ? '' : 'col-date'">Created Date</th>
          <td mat-cell *matCellDef="let sponsor"> {{sponsor.CreatedDate | date:'shortDate' }} </td>
        </ng-container>


        <ng-container matColumnDef="ModifiedBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="isCustomUiChange ? '' : 'col-date'">ModifiedBy</th>
          <td mat-cell *matCellDef="let sponsor" matTooltip="{{ sponsor.ModifiedBy }}"> {{sponsor.ModifiedBy }} </td>
        </ng-container>


        <ng-container matColumnDef="edit" stickyEnd>
          <th mat-header-cell *matHeaderCellDef mat-sort-header  [ngClass]="isCustomUiChange ? '' : 'col-edit'"></th>
          <td mat-cell *matCellDef="let sponsor">
            <button mat-button (click)="handleClick(sponsor)">
              <mat-icon matTooltip="Edit" color="primary">create</mat-icon>
            </button>

          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="isCustomUiChange ? '' : 'curr-cust'"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5,10,20]" showFirstLastButtons></mat-paginator>
    </mat-card-content>
  </mat-card>
</div>

<div  [ngClass]="isCustomUiChange ? '' : 'bottm-space'"></div>